function getPlatform() {
    const userAgent = navigator.userAgent.toLowerCase();
    const platformMap = {
      android: 'Android',
      ios: 'iOS',
      win: 'Windows',
      mac: 'Mac',
      linux: 'Linux',
    };
    const platform = Object.keys(platformMap).find((key) => new RegExp(key, 'i').test(userAgent));
    if (platform) {
      return platformMap[platform];
    }
  
    return 'OS unknown';
  }

  export { getPlatform };